import { render, staticRenderFns } from "./properties-component-background.vue?vue&type=template&id=65ad6518&scoped=true"
import script from "./properties-component-background.vue?vue&type=script&lang=js"
export * from "./properties-component-background.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ad6518",
  null
  
)

export default component.exports